import type { ThemeSchemaResponse } from '@api/api/theme-overview';

import { useMemo } from 'react';
import { buildSentimentBreakdown } from '../utils/buildSentimentBreakdown';
import { useSentimentScope } from './useSentimentScope';
import { useThemeMentions } from './useThemeMentions';

export const usePulseSentimentBreakdown = (theme: ThemeSchemaResponse) => {
  const scope = useSentimentScope(theme);
  const mentions = useThemeMentions({
    ...scope,
    enabled: scope.isReady,
  });

  return {
    data: useMemo(() => {
      if (!mentions.data || !scope.isReady) {
        return undefined;
      }

      return buildSentimentBreakdown(mentions.data.mentions);
    }, [mentions.data, scope.isReady]),
    isLoading: mentions.isLoading || scope.isLoading,
    isError: mentions.isError || scope.isError,
  };
};
